// extracted by mini-css-extract-plugin
export default {"root":"pTWe_CYU"};